/* Health Revival 101: cinematic scenic hero (journey camera or crossfade, scroll parallax, light motes, pause) */
(function () {
  if (customElements.get('hr-cinema')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class HrCinema extends HTMLElement {
    connectedCallback() {
      this.scenes = [...this.querySelectorAll('.hcx__scene')];
      this.dots = [...this.querySelectorAll('.hcx__dots i')];
      this.caps = [...this.querySelectorAll('[data-cap]')];
      this.video = this.querySelector('video');
      this.media = this.querySelector('.hcx__media');
      this.headEl = this.querySelector('.hcx__head');
      this.bar = this.querySelector('.hcx__bar');
      this.ms = (parseFloat(this.dataset.speed) || 9) * 1000;
      this.i = 0;
      this.mode = this.dataset.mode;
      this.leaves = this.querySelector('.hcx__leaves');
      this.haze = this.querySelector('.hcx__haze');
      this.go(0);
      this.measureHead = () => {
        const els = [...document.querySelectorAll('.shopify-section-group-header-group, #shopify-section-header, header')];
        if (!els.length) return;
        const bottom = Math.max(...els.map((e) => e.getBoundingClientRect().bottom));
        const gap = Math.round(bottom - this.getBoundingClientRect().top);
        this.style.setProperty('--hcx-head', (gap > 0 && gap < 260 ? gap : 0) + 'px');
        const top = Math.round(this.getBoundingClientRect().top + window.scrollY);
        this.style.setProperty('--hcx-top', (top > 0 && top < 260 ? top : 0) + 'px');
      };
      this.measureHead();
      window.addEventListener('resize', this.measureHead);
      window.addEventListener('load', this.measureHead);
      if (reduce && this.mode === 'journey' && this.scenes.length) this.go(this.scenes.length - 1);
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
      this.play();

      const cue = this.querySelector('[data-scroll]');
      if (cue) cue.addEventListener('click', (e) => {
        const host = this.closest('.shopify-section'); const next = host && host.nextElementSibling;
        if (!next) return;
        e.preventDefault(); next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
      if (this.video) this.video.addEventListener('ended', () => this.classList.add('is-ended'));
      const btn = this.querySelector('.hcx__pause');
      if (btn) btn.addEventListener('click', () => this.toggle(btn));
      if (reduce) { this.paused = true; this.classList.add('is-paused'); if (btn) btn.setAttribute('aria-pressed', 'true'); this.video && this.video.pause(); }

      this.vis = new IntersectionObserver((es) => es.forEach((e) => { this.inView = e.isIntersecting; if (this.inView) this.loop(); }));
      this.vis.observe(this);
      if (!reduce && this.dataset.parallax === 'true') {
        this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.scroll(); }); };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.scroll();
      }
      if (!reduce && this.dataset.motes !== '0') this.motes();
      this.vis2 = () => document.hidden ? this.stop() : this.play();
      document.addEventListener('visibilitychange', this.vis2);
    }
    go(n) {
      if (!this.scenes.length) return;
      const prev = this.i;
      this.i = (n + this.scenes.length) % this.scenes.length;
      this.scenes.forEach((s, k) => { s.classList.toggle('was-active', k === prev && k !== this.i); s.classList.toggle('is-active', k === this.i); });
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.i));
      this.caps.forEach((c, k) => { c.hidden = k !== this.i; });
    }
    play() {
      this.stop();
      if (this.paused || this.scenes.length < 2) return;
      if (this.mode === 'journey') { this.journey(); return; }
      this.t = setInterval(() => this.go(this.i + 1), this.ms);
    }
    stop() { clearInterval(this.t); cancelAnimationFrame(this.jraf); this.jlast = 0; }
    /* One continuous camera move: each scene starts close and low, the camera rises and pulls back,
       the next scene emerges through passing foliage (low scenes) or cloud haze (high scenes). */
    journey() {
      const n = this.scenes.length;
      const T = (parseFloat(this.dataset.journey) || 20) * 1000;
      const w = this.scenes.map((_, k) => (k === n - 1 ? 1.6 : 1));
      const sum = w.reduce((a, b) => a + b, 0);
      const dur = w.map((x) => (x / sum) * T);
      const start = dur.map((_, k) => dur.slice(0, k).reduce((a, b) => a + b, 0));
      const X = Math.min(Math.min(...dur) * 0.4, 2800);
      const loop = this.dataset.loop !== 'false';
      const ease = (x) => (x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2);
      const cl = (x) => Math.min(Math.max(x, 0), 1);
      const leafUntil = parseInt(this.dataset.leafy, 10) || 2;
      this.jt = this.jt || 0;
      const tick = (now) => {
        if (this.jlast) this.jt += Math.min(now - this.jlast, 50);
        this.jlast = now;
        let t = loop ? this.jt % T : Math.min(this.jt, T - 1);
        let top = 0, leafA = 0, hazeA = 0;
        this.scenes.forEach((sc, k) => {
          let tk = t;
          if (k === 0 && loop && t > T - X) tk = t - T;
          const from = start[k] - X;
          const span = dur[k] + X;
          const e = ease(cl((tk - from) / span));
          const a = k === 0 && !(loop && t > T - X) ? 1 : ease(cl((tk - from) / X));
          const end = k === n - 1 ? T + 1 : start[k + 1] + 1;
          const vis = tk >= from - 1 && tk <= end;
          const wrap = k === 0 && loop && t > T - X;
          sc.style.zIndex = wrap ? n + 1 : k + 1;
          sc.style.opacity = vis ? a : 0;
          sc.style.transform = 'translate3d(0,' + (-6 + 10 * e).toFixed(3) + '%,0) scale(' + (1.6 - 0.5 * e).toFixed(4) + ')';
          sc.style.filter = a < 1 ? 'blur(' + ((1 - a) * 10).toFixed(2) + 'px) brightness(' + (1 + (1 - a) * 0.25).toFixed(3) + ')' : 'none';
          if (vis && a > 0.5) top = k;
          if (vis && a > 0 && a < 1) {
            const pass = Math.sin(Math.PI * a);
            if (wrap || k > leafUntil) hazeA = Math.max(hazeA, pass * (wrap ? 0.95 : 0.55));
            else leafA = Math.max(leafA, a);
          }
        });
        if (this.leaves) {
          this.leaves.style.opacity = leafA > 0 && leafA < 1 ? Math.sin(Math.PI * leafA).toFixed(3) : 0;
          this.leaves.style.transform = 'translate3d(0,' + (-70 + 170 * leafA).toFixed(2) + '%,0) scale(' + (1.25 - 0.25 * leafA).toFixed(3) + ')';
        }
        if (this.haze) this.haze.style.opacity = hazeA.toFixed(3);
        if (top !== this.i) { this.i = top; this.dots.forEach((d, k) => d.classList.toggle('is-active', k === top)); this.caps.forEach((c, k) => { c.hidden = k !== top; }); }
        if (!this.paused && this.isConnected) this.jraf = requestAnimationFrame(tick);
      };
      this.jraf = requestAnimationFrame(tick);
    }
    toggle(btn) {
      this.paused = !this.paused;
      this.classList.toggle('is-paused', this.paused);
      btn.setAttribute('aria-pressed', String(this.paused));
      btn.setAttribute('aria-label', this.paused ? btn.dataset.play : btn.dataset.pause);
      if (this.video) this.paused ? this.video.pause() : this.video.play().catch(() => {});
      this.paused ? this.stop() : this.play();
      if (!this.paused) this.loop();
    }
    scroll() {
      const r = this.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      const p = Math.min(Math.max(-r.top / r.height, 0), 1);
      if (this.media) this.media.style.transform = 'translate3d(0,' + (p * 22) + '%,0) scale(' + (1 + p * 0.06) + ')';
      if (this.headEl) { this.headEl.style.transform = 'translate3d(0,' + (p * -18) + 'vh,0) scale(' + (1 + p * 0.12) + ')'; this.headEl.style.opacity = String(Math.max(1 - p * 1.6, 0)); }
      if (this.bar) this.bar.style.opacity = String(Math.max(1 - p * 2.4, 0));
    }
    motes() {
      const c = document.createElement('canvas');
      c.className = 'hcx__motes'; c.setAttribute('aria-hidden', 'true');
      const shade = this.querySelector('.hcx__shade');
      shade ? shade.before(c) : this.append(c);
      this.ctx = c.getContext('2d'); this.cv = c;
      const n = parseInt(this.dataset.motes, 10) || 46;
      const size = () => { const d = Math.min(window.devicePixelRatio || 1, 2); c.width = c.offsetWidth * d; c.height = c.offsetHeight * d; this.d = d; };
      size(); this.onResize = size; window.addEventListener('resize', size);
      this.pts = Array.from({ length: n }, () => ({ x: Math.random(), y: Math.random(), r: 0.6 + Math.random() * 1.9, s: 0.00006 + Math.random() * 0.00016, w: Math.random() * Math.PI * 2, a: 0.15 + Math.random() * 0.5, t: Math.random() < 0.25 }));
      this.loop();
    }
    loop() {
      if (!this.ctx || this.running) return;
      this.running = true;
      let last = performance.now();
      const step = (now) => {
        if (!this.inView || this.paused || !this.isConnected) { this.running = false; return; }
        const dt = Math.min(now - last, 50); last = now;
        const { ctx, cv } = this; const W = cv.width, H = cv.height;
        ctx.clearRect(0, 0, W, H);
        for (const p of this.pts) {
          p.y -= p.s * dt; p.w += dt * 0.0006; p.x += Math.sin(p.w) * 0.00012 * dt;
          if (p.y < -0.05) { p.y = 1.05; p.x = Math.random(); }
          const tw = 0.6 + Math.sin(p.w * 3) * 0.4;
          const R = p.r * this.d * 3;
          const g = ctx.createRadialGradient(p.x * W, p.y * H, 0, p.x * W, p.y * H, R);
          g.addColorStop(0, p.t ? 'rgba(160,255,240,' + p.a * tw + ')' : 'rgba(255,255,245,' + p.a * tw + ')');
          g.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x * W, p.y * H, R, 0, Math.PI * 2); ctx.fill();
        }
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
    disconnectedCallback() {
      this.stop(); this.vis && this.vis.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('visibilitychange', this.vis2);
    }
  }
  customElements.define('hr-cinema', HrCinema);
})();
